export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500">编辑精选优质内容，不错过每一部好作品</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer">
            <div className="aspect-video w-full overflow-hidden bg-background-200 relative">
              <img src="https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manga%20splash%20page%20with%20divine%20light%20and%20powerful%20aura%2C%20warm%20golden%20and%20blue-green%20tones%2C%20epic%20composition%2C%20editorial%20quality%20on%20cream%20background&width=800&height=450&seq=media-01&orientation=landscape" alt="51漫画网 - 斗罗大陆最新话" className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center cursor-pointer transition-transform duration-200 hover:scale-110">
                  <div className="w-0 h-0 border-l-[14px] border-l-primary-600 border-y-[10px] border-y-transparent ml-1"></div>
                </div>
              </div>
            </div>
            <div className="p-4">
              <span className="inline-block px-2 py-0.5 text-xs font-medium text-primary-700 bg-primary-100/70 rounded-full mb-2">热门连载</span>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">《斗罗大陆》最新话</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">唐三突破极限，海神传承进入关键时刻，精彩不容错过</p>
            </div>
          </div>

          <div className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer">
            <div className="aspect-video w-full overflow-hidden bg-background-200 relative">
              <img src="https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manga%20art%20with%20ancient%20relics%20and%20mystical%20energy%2C%20warm%20earthy%20toned%20with%20jade%20green%20accents%2C%20editorial%20quality%20on%20cream%20background&width=800&height=450&seq=media-02&orientation=landscape" alt="51漫画网 - 完美世界特别篇" className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center cursor-pointer transition-transform duration-200 hover:scale-110">
                  <div className="w-0 h-0 border-l-[14px] border-l-primary-600 border-y-[10px] border-y-transparent ml-1"></div>
                </div>
              </div>
            </div>
            <div className="p-4">
              <span className="inline-block px-2 py-0.5 text-xs font-medium text-primary-700 bg-primary-100/70 rounded-full mb-2">特别推荐</span>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">《完美世界》特别篇</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">石昊闯荡九天十地，秘境探险揭开上古谜团</p>
            </div>
          </div>

          <div className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer">
            <div className="aspect-video w-full overflow-hidden bg-background-200 relative">
              <img src="https://readdy.ai/api/search-image?query=Urban%20Chinese%20manga%20scene%20with%20modern%20buildings%20and%20supernatural%20energy%2C%20warm%20amber%20lighting%2C%20dynamic%20composition%2C%20editorial%20quality%20on%20cream%20background&width=800&height=450&seq=media-03&orientation=landscape" alt="51漫画网 - 一人之下深度解析" className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center cursor-pointer transition-transform duration-200 hover:scale-110">
                  <div className="w-0 h-0 border-l-[14px] border-l-primary-600 border-y-[10px] border-y-transparent ml-1"></div>
                </div>
              </div>
            </div>
            <div className="p-4">
              <span className="inline-block px-2 py-0.5 text-xs font-medium text-primary-700 bg-primary-100/70 rounded-full mb-2">深度解读</span>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">《一人之下》深度解析</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">异人世界格局巨变，冯宝宝身世之谜即将揭晓</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}